import { ApiServerGetAvailable, AppThunk, Server } from 'types';
import * as actions from 'store/actions';
import _get from 'lodash/get';
import { apiPost } from './shared/api';
import { authCheckLogin } from './auth';

export const getAvailableServers = (): AppThunk<Promise<void>> => async (dispatch, getState) => {
  if (getState().app.loadingServers) return;
  dispatch(actions.getAvailableServersStart());
  const storedSelectedServer = localStorage.getItem('selectedServer');
  const selectedServer = JSON.parse(storedSelectedServer || '{}') as Server | undefined;
  if (selectedServer?.Id) {
    dispatch(actions.setSelectedServerSuccess(selectedServer));
  }
  try {
    const response = await dispatch(apiPost<ApiServerGetAvailable>('serverGetAvailable', {}));
    if (response) {
      const servers = response.payload.Servers;
      dispatch(actions.getAvailableServersSuccess(servers));
      await dispatch(authCheckLogin());
    }
  } catch (error) {
    if (_get(error, 'response')) dispatch(actions.getAvailableServersFailed(_get(error, 'response.error_message')));
  }
};

export const setSelectedServer = (server: Server): AppThunk => {
  return (dispatch) => {
    dispatch(actions.setSelectedServerStart());
    dispatch(actions.logout());
    dispatch(actions.setSelectedServerSuccess(server));
    localStorage.setItem('selectedServer', JSON.stringify(server));
  };
};

export default {};
